import { getApiInstance, getOAuthToken } from './ApiToken'

export default {
  async getBaseline (baselineId) {
    const api = await getApiInstance()
    try {
      const response = api.get('baseline/baseline/' + baselineId)
      return response
    } catch (error) {
      if (error.response && error.response.status === 401) {
        getOAuthToken()
        const api = getApiInstance()
        const response = api.get('baseline/baseline/' + baselineId)
        return response
      }
      throw error
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/BaselineService.js